<template>
    <div class="hzhb-container">
        <section-title :titleInfo="coopTitleInfo"></section-title>
        <div class="coop-list">
            <article
                v-for="(item, index) in coopList"
                :key="item.title"
                class="coop-item"
            >
                <span class="coop-index">{{ formatIndex(index) }}</span>
                <div class="coop-body">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.text }}</p>
                </div>
            </article>
        </div>

        <section-title :titleInfo="titleInfo"></section-title>
        
        <div class="hzhb-list">
            <div class="hzhb-item hzhb-item1" :class="{'hzhb-item-large': flag1}">
                <div class="hzhb-item-title">
                    <div class="hzhb-title-num">
                        <img class="hzhb-title-num-pic" src="../images/hzhb-num-one.png" alt="">
                    </div>
                    <div class="hzhb-title">
                        共同经营
                    </div>
                    <div class="title-arrow" :class="{'title-arrow-bottom': flag1}" @click="handleTranFlag1">
                    </div>
                </div>
                <div class="hzhb-item-cont">
                    加盟商可选择与我方按股份分成共同经营，并可接入我方平台，充分利用多个合伙人的资源和能力，提高企业的竞争力和创造力，同时减轻个人承担风险的压力。
                </div>

                <div class="hzhb-ys-container" v-if="flag1">
                    <div class="hzhb-ys-title">
                        优势
                    </div>
                    <div class="hzhb-ys-cont">
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                资金充足
                            </span>：多个合伙人共同投入资金，可以提供更多的资金用于业务运营和发展。
                        </div>
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                技能和经验的互补
                            </span>：合伙人之间可以互相补充技能和经验，提高业务的专业性和竞争力。
                        </div>
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                资源共享
                            </span>：合伙人之间可以共享资源，如人脉关系、客户资源等，扩大业务发展。
                        </div>
                    </div>
                </div>

                <div class="hzhb-btn-container">
                    <div class="hzhb-btn">
                        成为合作伙伴
                    </div>
                </div>
            </div>
            <div class="hzhb-item hzhb-item2" :class="{'hzhb-item-large': flag2}">
                <div class="hzhb-item-title">
                    <div class="hzhb-title-num">
                        <img class="hzhb-title-num-pic" src="../images/hzhb-num-two.png" alt="">
                    </div>
                    <div class="hzhb-title">
                        三方合作
                    </div>
                    <div class="title-arrow" :class="{'title-arrow-bottom': flag2}" @click="handleTranFlag2">
                    </div>
                </div>
                <div class="hzhb-item-cont">
                    与引流平台和充电桩供应商建立合作关系，将充电桩的实时数据和位置信息提供给引流平台，确保引流平台提供的充电信息准确性和实时性。通过引流平台提供的充电服务信息，吸引用户使用其管辖区域内的充电桩，从而增加设施的利用率和收入。各方通过技术和服务的协同合作，共同推动充电基础设施的发展和利用率提升。
                </div>

                <div class="hzhb-ys-container" v-if="flag2">
                    <div class="hzhb-ys-title">
                        优势
                    </div>
                    <div class="hzhb-ys-cont">
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                扩大市场
                            </span>：基于第三方平台加入我们，可借助平台的品牌影响力和用户基础，快速进入新市场，扩大业务范围。
                        </div>
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                减少工作量
                            </span>：可以减少自行开展市场调研、营销策划等工作的时间和精力，快速进入市场并专注于核心业务。
                        </div>
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                节约成本
                            </span>：可以共享资源和成本，减少重复性投入和浪费。通过合作，共同利用设备、人力和技术等资源，降低合作过程中的成本，提高效率和利润。
                        </div>
                    </div>
                </div>

                <div class="hzhb-btn-container">
                    <div class="hzhb-btn">
                        成为合作伙伴
                    </div>
                </div>
            </div>
            <div class="hzhb-item hzhb-item3" :class="{'hzhb-item-large': flag3}">
                <div class="hzhb-item-title">
                    <div class="hzhb-title-num">
                        <img class="hzhb-title-num-pic" src="../images/hzhb-num-three.png" alt="">
                    </div>
                    <div class="hzhb-title">
                        特许经营
                    </div>
                    <div class="title-arrow" :class="{'title-arrow-bottom': flag3}" @click="handleTranFlag3">
                    </div>
                </div>
                <div class="hzhb-item-cont">
                    加盟商可以在授权范围内经营并销售我方的产品或服务，并通常享受特许权人提供的支持和指导。
                </div>

                <div class="hzhb-ys-container" v-if="flag3">
                    <div class="hzhb-ys-title">
                        优势
                    </div>
                    <div class="hzhb-ys-cont">
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                高品牌知名度
                            </span>：加盟商可以使用我司已经建立的品牌，无需从零开始建立品牌认知度。
                        </div>
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                经营支持和指导
                            </span>：我司通常提供培训、运营指导、营销支持等方面的支持，帮助加盟商更。
                        </div>
                        <div class="hzhb-ys-cont-item">
                            <span class="cont-item-label">
                                共享市场经验和成功模式
                            </span>：加盟商可以分享我方在市场上积累的经验和成功模式，从而降低经营风险。更快速的启动和扩大业务。
                        </div>
                    </div>
                </div>

                <div class="hzhb-btn-container">
                    <div class="hzhb-btn">
                        成为合作伙伴
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import sectionTitle from '../../components/section-title.vue'
    export default {
        components: { sectionTitle },
        data(){
            return {
                coopTitleInfo: {
                    bigtext1: "合作成果",
                    smallText: "产学研协同、奖项认可与重点项目落地，持续拓展行业合作边界",
                },
                titleInfo:{
                    bigtext1: "合作模式",
                },
                coopList: [
                    {
                        title: "江苏省科技重大专项",
                        text: "与东南大学、天津大学、南京德睿特来电能源研究院有限公司合作申报2026年江苏省科技厅科技重大专项项目。",
                    },
                    {
                        title: "电力建设科技进步奖",
                        text: "国能南京电力试验研究有限公司，国家能源集团科学技术研究院有限公司，东南大学等单位共同获得2024年电力建设科学技术进步奖一等奖。",
                    },
                    {
                        title: "国家重点研发计划配套示范",
                        text: "与国网江苏省电力有限公司电力科学研究院共同参与完成国家重点研发计划“高效协同充换电关键技术及装备”项目的重要配套示范项目——“国网江苏车联网平台省级应用系统优化-设计开发及实施”。",
                    },
                    {
                        title: "研究生实践基地",
                        text: "与东南大学联合建立研究生实践基地。",
                    },
                ],
                flag1: false,
                flag2: false,
                flag3: false
            }
        },

        methods:{
            formatIndex(index) {
                return String(index + 1).padStart(2, "0");
            },
            handleTranFlag1(){
                this.flag1 = !this.flag1
            },
            handleTranFlag2(){
                this.flag2 = !this.flag2
            },
            handleTranFlag3(){
                this.flag3 = !this.flag3
            }
        }
        


    }
</script>

<style lang="scss" scoped>
.hzhb-container{
    width: 100%;
    box-sizing: border-box;
    padding: 100px 160px;
    background-color: #F6F6F6;

    .coop-list {
        width: 100%;
        margin: 36px 0 92px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 22px;
    }

    .coop-item {
        min-height: 168px;
        box-sizing: border-box;
        padding: 28px 30px;
        display: flex;
        gap: 20px;
        border: 1px solid #e4ebf5;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 12px 30px rgba(31, 99, 234, 0.08);
        transition: transform 0.25s, box-shadow 0.25s, border-color 0.25s;

        &:hover {
            transform: translateY(-4px);
            border-color: #b8d3ff;
            box-shadow: 0 18px 40px rgba(31, 99, 234, 0.14);
        }
    }

    .coop-index {
        flex: none;
        width: 52px;
        height: 52px;
        display: grid;
        place-items: center;
        border-radius: 14px;
        color: #1f63ea;
        font-size: 18px;
        font-weight: 700;
        background: linear-gradient(180deg, #edf4ff, #f7faff);
        border: 1px solid #d4e6ff;
    }

    .coop-body {
        min-width: 0;
        flex: 1;

        h3 {
            margin: 4px 0 12px;
            color: #1d1d1d;
            font-size: 22px;
            font-weight: 600;
            line-height: 1.4;
        }

        p {
            margin: 0;
            color: #52627c;
            font-size: 16px;
            line-height: 1.8;
        }
    }

    .hzhb-list{
        width: 100%;
        display: flex;
        justify-content: space-around;
        .hzhb-item{
            flex-basis: 32%;
            height: 500px;
            background: #FFFFFF;
            box-shadow: 0px 25px 89px 1px rgba(31,99,234,0.12);
            border-radius: 12px 12px 12px 12px;
            box-sizing: border-box;
            padding: 0 41px;
            position: relative;
            .hzhb-item-title{
                width: 100%;
                height: 90px;
                line-height: 100px;
                border-bottom: 1px solid #D4E6FF;
                position: relative;
                margin-bottom: 20px;
                .hzhb-title-num{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 65px;
                    height: 68px;
                    z-index: 99;
                    background: linear-gradient( 180deg, rgba(31,99,234,0.95) 0%, rgba(31,99,234,0) 100%);
                    .hzhb-title-num-pic{
                        position: absolute;
                        width: 22px 36px;
                        top: 10px;
                        left: 22px;
                        z-index: 999;
                    }
                }
                .hzhb-title{
                    width: 100%;
                    height: 100%;
                    font-weight: bold;
                    font-size: 32px;
                    color: #1D1D1D;
                }
                .title-arrow{
                    position: absolute;
                    width: 38px;
                    height: 38px;
                    top: 30px;
                    right: 0px;
                    cursor: pointer;
                    background-image: url('../images/hzhb-arrow-right.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                .title-arrow-bottom{
                    background-image: url('../images/hzhb-arrow-bottom.png');
                }
            }
            .hzhb-item-cont{
                width: 100%;
                font-weight: 400;
                font-size: 18px;
                color: #1D1D1D;
                line-height: 36px;
            }
            .hzhb-ys-container{
                width: 100%;
                box-sizing: border-box;
                padding: 30px 0 50px;
                .hzhb-ys-title{
                    width: 100%;
                    height: 24px;
                    background-image: url('../images/hzhb-ys-bg.png');
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    color: #1F63EA;
                    font-size: 18px;
                    margin-bottom: 20px;
                }
                .hzhb-ys-cont{
                    width: 100%;
                    .hzhb-ys-cont-item{
                        margin-bottom: 20px;
                        color: #1D1D1D;
                        font-size: 18px;
                        font-weight: 400;
                        .cont-item-label{
                            font-weight: bold;
                        }
                    }

                }

            }

            .hzhb-btn-container{
                position: absolute;
                bottom: 30px;
                left: 0;
                width: 100%;
                text-align: center;
                height: 58px;
                /* margin-bottom: 43px;
                margin-top: 40px; */
                .hzhb-btn{
                    width: 186px;
                    height: 58px;
                    line-height: 58px;
                    font-weight: 400;
                    font-size: 18px;
                    color: #FFFFFF;
                    cursor: pointer;
                    display: inline-block;
                    background-image: url('../images/hzhb-btn-bg.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position: center;
                }
            }
        }
        .hzhb-item-large{
            height: 900px;
        }
    }

}

@media (max-width: 1100px) {
  .hzhb-container {
    padding: 70px 24px;

    .coop-list {
      grid-template-columns: 1fr;
      margin-bottom: 64px;
    }
  }
}
</style>


